import { PageSize } from '@/constant';
import {
	IDeviceLogItem,
	IGetDeviceLogListParams,
} from '@/services/api/api.type';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDeviceLogListRequest,
	IPayloadGetDeviceLogListSuccess,
} from './device-log.type';

const InitParams: IGetDeviceLogListParams = {
	page: 1,
	pageSize: PageSize.XS,
};

const initialState = {
	fetching: false,
	list: [] as IDeviceLogItem[],
	total: 0,
	params: InitParams,
};

const deviceLogSlice = createSlice({
	initialState,
	name: 'deviceLog',
	reducers: {
		/**---- GET DEVICE_LOG LIST START ---- */
		getDeviceLogListRequest: (
			state,
			_action: PayloadAction<IPayloadGetDeviceLogListRequest>
		) => {
			state.fetching = true;
			state.params = _action?.payload;
		},
		getDeviceLogListSuccess: (
			state,
			action: PayloadAction<IPayloadGetDeviceLogListSuccess>
		) => {
			const { list, totalCount } = action.payload;
			state.fetching = false;
			state.list = list;
			state.total = totalCount;
		},
		getDeviceLogListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET DEVICE_LOG LIST END ---- */
	},
});

export const DeviceLogSelectors = {
	selectFetching: (state: RootState) => state.deviceLog.fetching,
	selectList: (state: RootState) => state.deviceLog.list,
	selectTotal: (state: RootState) => state.deviceLog.total,
	selectParams: (state: RootState) => state.deviceLog.params,
};

export const DeviceLogActions = deviceLogSlice.actions;
export const DeviceLogReducer = deviceLogSlice.reducer;
